import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import { ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME } from '../../constants';
import {
  ADMIN_AFFILIATE_TRACKERS_GROUPS_ROUTE_NAME,
  AFFILIATES_TRACKER_GROUPS_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_GROUPS,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedTrackerGroupsModule extends AppModule {
  protected submodules: AppModule[] = [];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_GROUPS_ROUTE_NAME,
      path: 'tracker-groups',
      permission: AFFILIATES_TRACKER_GROUPS_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateTrackerGroupsPage/AffiliateTrackerGroupsPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_GROUPS, getTranslationKeys);
  }
}
